module.exports = __webpack_public_path__ + "img/sudafed_pe_tablets.3df8fa36.jpeg";